export const sv = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Tillbaka",
        save: "Spara",
        saved: "Sparad",
        cancel: "Avbryt",
        close: "Stäng",
        accessDenied: "Åtkomst nekad",
        noExportPermission: "Du har inte behörighet att exportera dessa biluppgifter.",
        delete: "Ta bort",
        downgrade: "Nedgradera",
        downgradeConfirm: "Är du säker på att du vill nedgradera till gratisplanen?",
        edit: "Redigera",
        loading: "Laddar...",
        confirm: "Bekräfta",
        processing: "Behandlar...",
        history: "Historik",
        currentCar: "Nuvarande Bil",
        purchasedCarTitle: "Bilköp",
        initialCost: "Inledande Kostnad",
        done: "Klart",
        ok: "OK",
        error: "Fel",
        errorSaving: "Fel vid sparande av data",
        mandatoryFieldsError: "Vänligen fyll i alla obligatoriska fält korrekt.",
        search: "Sök",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Ogiltigt e-postformat",
        today: "Idag",
        car: "Bil",
        all: "Alla",
        deleteConfirm: "Ta bort",
        unsavedChangesTitle: "Ej Sparade Ändringar",
        unsavedChangesMessage: "Vill du spara ändringar innan du lämnar?",
        dontSave: "Spara inte",
        additionalOptions: "Ytterligare alternativ",
        add: "Lägg till",
        fileTooLarge: "Fil är för stor. Maximal storlek är {limit} MB.",
        storageFull: "Lagringsgräns överskriden. Maximal lagring är {limit} MB.",
        dailyUploadLimit: "Dagsgräns för uppladdning nådd ({limit} filer/dag). Försök igen imorgon.",
        hourlyUploadLimit: "Timgräns för uppladdning nådd ({limit} filer/timme). Försök igen om en timme.",
        fileCountLimit: "Maximalt {limit} filer tillåtna per objekt.",
        emailParseLimitReached: "Gräns för e-postanalys nådd. Vänligen uppgradera din plan eller behandla manuellt.",
        emailLimitText: "Gräns för e-postbehandling nådd.",
        monthlyEmailScans: "Månatliga E-postskanningar",
        lifetimeEmailScans: "Livstids E-postskanningar",
        monthlyFileScans: "Månatliga Kvitto-skanningar",
        lifetimeFileScans: "Livstids Kvitto-skanningar",
        fileLimitText: "Gräns för kvitto-skanning nådd.",
        planFreeTier: "Gratis nivå",
        planProTier: "Pro nivå",
        uploadFailed: "Uppladdning misslyckades",
        attachments: "Bifogade filer",
        limitsAndUsage: "Gränser & Användning",
        addresses: "adresser",
        emailCopied: "E-postadress kopierad!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Inkluderad",
        proOnly: "PRO endast",
        month: "må",
        openInNewTab: "Öppna i ny flik",
        menu: "Meny",
        home: "Hem",
        monthsShort: {
            0: "Jan",
            1: "Feb",
            2: "Mar",
            3: "Apr",
            4: "Maj",
            5: "Jun",
            6: "Jul",
            7: "Aug",
            8: "Sep",
            9: "Okt",
            10: "Nov",
            11: "Dec",
        },
    },
    carMetadata: {
        bodyType: "Karosstyp",
        drivetrain: "Drivlina",
        transmission: "Växellåda",
        bodyTypes: {
            sedan: "Sedan",
            hatchback: "Hatchback",
            wagon: "Kombi",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupé",
            convertible: "Cabriolet",
            pickup: "Pickup",
            van: "Skåpbil / Minivan",
            commercial: "Kommersiell",
            other: "Annat",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Annat",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manuell",
            automatic: "Automatisk",
            cvt: "CVT",
            other: "Annat",
        },
        otherLabel: "Annat (specificera)",
        mileageLabel: "Körsträcka",
    },
    auth: {
        welcome: "Välkommen",
        welcomeBack: "Välkommen Tillbaka",
        signIn: "Logga In",
        signInWithGoogle: "Logga in med Google",
        signOut: "Logga Ut",
        magicLinkDesc: "Få en magisk länk i din e-post",
        magicLinkSent: "Magisk länk skickad!",
        magicLinkCheckEmail: "Kontrollera din e-post och klicka på länken för att logga in.",
        emailAddress: "E-postadress",
        getMagicLink: "Få Magisk Länk",
        sending: "Skickar...",
        linkSent: "Länk skickad",
        orContinueWith: "Eller fortsätt med",
        googleAccount: "Google-konto",
        newUserNote: "Ny här? Ditt konto kommer att skapas automatiskt vid din första lyckade inloggning.",
        magicLinkError: "Misslyckades med att skicka magisk länk. Vänligen kontrollera din e-post och försök igen.",
        genericError: "Ett fel inträffade. Vänligen försök igen.",
        projectDescription: "Håll koll på dina bilkostnader, underhåll och historik på ett ställe.",
        loginError: "Kunde inte logga in",
        loggingIn: "Loggar in...",
        authenticating: "Autentiserar...",
        authenticatingDesc: "Vänligen vänta medan vi säkrar din session.",
    },
    settings: {
        title: "Inställningar",
        systemPreferences: "Systeminställningar",
        appSettings: "Appinställningar",
        dangerZone: "Farlig Zon",
        theme: "Tema",
        language: "Gränssnittsspråk",
        currency: "Valuta",
        units: "Enheter",
        distanceUnit: "Avståndsenhet",
        volumeUnit: "Volymenhet",
        expenseTypes: "Utgiftstyper",
        expenseTypesDesc: "Hantera kategorier",
        categories: "Kategorier",
        exportData: "Exportera data",
        exportDesc: "Ladda ner omfattande CSV",
        importData: "Importera data",
        importDesc: "Återställ från CSV-säkerhetskopia",
        deleteAccount: "Ta bort konto",
        deleteAccountDesc: "Ta bort all data permanent",
        enableSync: "Aktivera synkronisering",
        enableSyncDesc: "Synkronisera data mellan enheter",
        account: "Konto",
        accountPlan: "Kontoplan",
        carsUsage: "Bilar",
        carsLimitReached: "Bilgräns nådd",
        storageSize: "Lagringsstorlek",
        emailScans: "E-postskanningar",
        fileScans: "Kvitto-skanningar",
        plans: "Planer",
        currentlyPlan: "För närvarande",
        upgradePlan: "Uppgradera",
        manageSubscription: "Hantera prenumeration",
        nextPayment: "Nästa betalning",
        endsOn: "Slutar den",
        adminConsole: "Administratörskonsol",
        systemControl: "Systemkontroll",
        customCategories: "Anpassade kategorier och etiketter",
        interfaceTheme: "Gränssnittstema",
        light: "Ljus",
        dark: "Mörk",
        timezone: "Tidszon",
        timezoneDesc: "Används för schemalagda e-postpåminnelser",
        timeFormat: "Tidsformat",
        timeFormat24h: "24-timmars (14:30)",
        timeFormat12h: "12-timmars (2:30 PM)",
        kilometers: "kilometer (km)",
        miles: "mil (mi)",
        liters: "liter (l)",
        gallons: "gallon (gal)",
        accountManagement: "Kontohantering",
        contactUs: "Kontakta oss",
        contactDesc: "För förslag, funktionsförfrågningar och frågor",
        logOut: "Logga ut",
        logOutConfirmTitle: "Logga ut",
        logOutConfirmMessage: "Är du säker på att du vill logga ut från ditt konto?",
        keepAccount: "Behåll konto",
        deleteAccountConfirmTitle: "Ta bort konto",
        deleteAccountConfirmMessage: "Är du säker på att du vill ta bort ditt konto och all associerad bilinformation permanent? Denna åtgärd kan inte ångras.",
        deletePermanently: "Ta bort permanent",
        deleting: "Tar bort...",
        contactSupport: "Kontakta support",
        messageSent: "Meddelande skickat!",
        feedbackThanks: "Tack för din feedback. Vi uppskattar ditt bidrag och kommer att titta på det.",
        backToSettings: "Tillbaka till inställningar",
        subjectLabel: "Ämne",
        messageLabel: "Meddelande",
        subjectPlaceholder: "Vad handlar detta om?",
        messagePlaceholder: "Berätta för oss om ditt förslag, funktionsförfrågan eller fråga...",
        enterSubjectAlert: "Vänligen ange ett ämne",
        enterMessageAlert: "Vänligen ange ett meddelande",
        sendFailedAlert: "Misslyckades med att skicka meddelande. Vänligen försök igen senare.",
    },
    export: {
        title: "Exportera data",
        generatePDF: "Generera PDF",
        carInformation: "Bilinformation",
        editInfo: "Redigera informationen nedan för att anpassa din export",
        editInfoHint: "Du kan ta bort eller ändra fält som du inte vill inkludera",
        filters: "Filter",
        expenseTypes: "Utgiftstyper",
        includeNotes: "Inkludera anteckningar",
        includeImages: "Inkludera filer",
        hideDisabled: "Dölj inaktiverade objekt",
        itemsCount: "{total} objekt, {selected} valda",
        selectAll: "Välj alla",
        deselectAll: "Avmarkera alla",
        expenses: "Utgifter",
        notes: "Anteckningar",
        spareParts: "Reservdelar",
        images: "Bilder",
        files: "Filer",
        summary: "Sammanfattning",
        totalExpenses: "Totala utgifter",
        totalItems: "Totala objekt",
        generatedOn: "Genererad den",
        noItemsSelected: "Inga objekt valda för export",
        noItemsAvailable: "Inga objekt tillgängliga för export",
        generating: "Genererar PDF...",
        downloadPDF: "Ladda ner PDF",
        pdfFileName: "{carName}_export_{date}.pdf",
        reportTitle: "Bilutgiftsrapport",
        exportButton: "Exportera",
        generateCSV: "Generera CSV",
        formatSelectorTitle: "Välj format",
        formatSelectorMsg: "Välj exportformat",
        proFeatureExportTitle: "Pro-funktion: Exportera data",
        proFeatureExportDesc: "Uppgradera till PRO för att exportera din bilhistorik till PDF.",
        exportRestrictedPopup: "Dataexport är endast tillgänglig för Pro-användare.",
        allTypes: "Alla typer",
        statistics: "Statistik",
        driven: "Körd",
        since: "Sedan",
        averageCost: "Genomsnittlig kostnad",
        perKm: "per km",
        perMile: "per mil",
        period: "Period",
        dateFrom: "Från",
        dateTo: "Till",
        allTime: "Rensa filter",
        periodHint: "Om ingen period är vald — visas alla utgifter",
        noExpenses: "Inga utgifter matchar filtren",
        expensesSection: "Utgifter",
        attachmentsSection: "Bilagor",
        imagesCount: "{count} bilder",
        pdfsCount: "{count} PDF-filer",
        includeParts: "Inkludera reservdelar",
        pageLabel: "Sida",
    },
    expenses: {
        title: "Utgifter",
        newExpense: "Ny utgift",
        editExpense: "Redigera utgift",
        openExpense: "Öppna utgiftsinlägg",
        details: "Utgiftsdetaljer",
        selectType: "Välj typ",
        selectTypePlaceholder: "Välj utgiftstyp...",
        shortDescriptionPlaceholder: "Kort beskrivning...",
        expenseTitle: "Titel",
        logEntryTitleLabel: "Registrera titel (Valfritt)",
        defaultTitlePlaceholder: "Standardtitel - {type}",
        autoTitlePlaceholder: "Kommer att fyllas i automatiskt baserat på valda typer",
        carDataTitle: "Biluppgifter",
        defaultTitlePrefix: "Standardtitel kommer att vara -",
        addAnother: "Lägg till en annan typ av utgift",
        addAnotherHint: "Om denna post inkluderar flera typer av utgifter kan du lägga till dem alla här för att säkerställa korrekta statistik.",
        carValueDescription: "Uppskattat marknadsvärde på bilen vid denna tidpunkt.",
        type: "Typ",
        date: "Datum",
        amount: "Belopp",
        totalAmount: "Totalt",
        splitCosts: "Dela kostnader?",
        combineCosts: "Kombinera kostnader",
        amountWork: "Arbete",
        amountParts: "Delar",
        mileage: "Körsträcka",
        carValue: "Bilvärde",
        description: "Beskrivning",
        detailedDescription: "Detaljerad beskrivning",
        electricity: "El",
        fuelType: "Bränsletyp",
        fuelTypeOptions: {
            petrol: "Bensin",
            diesel: "Diesel",
            lpg: "LPG",
            electricity: "El",
        },
        carData: "Bilinformation",
        images: "Filer",
        addImages: "Lägg till filer",
        addImagesPDFs: "Lägg till bilder eller PDF-filer",
        deleteExpense: "Ta bort utgift",
        deleteConfirm: "Är du säker på att du vill ta bort denna utgift?",
        saveSuccess: "Utgift sparad framgångsrikt",
        thisExpense: "Denna utgift",
        stats: {
            annual: "Årlig",
            allTime: "Genom tiderna",
            avgMonth: "Genomsnitt/månad",
            costPer: "Kostnad/",
            noExpenses: "Inga utgifter ännu",
            dragToReorder: "Dra handtag för att omordna",
        },
        expensesFound: "Skapade",
        noExpensesFound: "Inga utgifter hittades.",
        noDescription: "Ingen beskrivning",
        imagesCount: "Bilder ({count})",
        deleteImageTitle: "Ta bort bild",
        deleteImageConfirm: "Är du säker på att du vill ta bort denna bild? Denna åtgärd kan inte ångras.",
        typeLabels: {
            fuel: "Bränsle",
            car_wash: "Tvätt",
            repairs: "Reparationer",
            maintenance: "Underhåll",
            parts: "Reservdelar",
            insurance: "Försäkring",
            inspection: "Inspektion",
            tyres: "Däck",
            parking: "Parkering",
            electricity: "El",
            taxes: "Skatter",
            other: "Annat",
            info: "Information",
            service_maintenance: "Underhåll",
            service_repair: "Reparation",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Service",
            selectSubtype: "Välj servicetyp",
            maintenance: "Underhåll",
            repair: "Reparation",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Återkommande kostnad",
        repeatToggle: "Upprepa denna kostnad",
        repeatFrequency: "Frekvens",
        monthly: "Månatligen",
        startDate: "Startdatum",
        nextDate: "Nästa post kommer att genereras",
        endDate: "Slutdatum",
        noEndDate: "Inget slutdatum",
        copyOptions: "Kopiera alternativ",
        copyTitle: "Kopiera posttitel",
        copyLocation: "Kopiera plats",
        copyDescription: "Kopiera beskrivning",
        active: "Aktiv",
        status: "Status",
        managedByRepeat: "Denna kostnad är en del av en upprepande sekvens.",
        placeholder: "Här kan du ställa in automatisk upprepning för denna kostnad om den inträffar regelbundet med samma belopp.",
        deleteRepeat: "Ta bort upprepning",
        deleteRepeatConfirm: "Är du säker på att du vill stoppa och ta bort denna upprepande sekvens? Framtida poster kommer inte att genereras. Tidigare poster kommer att förbli.",
        relatedEntries: "Poster i denna sekvens",
        stopRepeat: "Sluta upprepa",
        isRepeating: "Upprepande",
        noTerm: "Obegränsat",
        until: "Sista posten kommer att genereras",
        summaryCopy: "Systemet kommer att kopiera",
        simulate: "Simulera nästa postgenerering",
        simulateSuccess: "Nästa postgenerering simulerades framgångsrikt",
        simulateNoDate: "Inga fler datum att generera (slutdatum nått)",
    },
    onboarding: {
        title: "Ställ in profil",
        welcome: "Välkommen!",
        subtitle: "Anpassa din körupplevelse.",
        currency: "Valuta",
        preferredCurrency: "Föredragen valuta",
        distUnit: "Avståndsenhet",
        volUnit: "Volymenhet",
        complete: "Slutför installation",
    },
    cars: {
        unitChangeWarningTitle: "Varning för enhetsändring",
        unitChangeWarningMessage: "Att ändra dessa enheter kommer inte att konvertera dina befintliga data. Alla historiska poster kommer att förbli exakt som de angavs.",
        unitChangeWarningConfirm: "Förstått",
        title: "Garage",
        carAdmins: "Biladministratörer",
        sharedWithMe: "Delad med mig",
        manageAdmins: "Hantera administratörer",
        adminEmail: "Administratörs-e-post",
        addAdmin: "Lägg till administratör",
        addAdminPlaceholder: "t.ex. vän@email.com",
        removeAdmin: "Ta bort",
        removeAdminConfirm: "Är du säker på att du vill ta bort denna administratör?",
        adminAdded: "Administratör tillagd",
        adminRemoved: "Administratör borttagen",
        removeMyAccess: "Ta bort min åtkomst",
        removeMyAccessConfirm: "Är du säker på att du vill ge upp åtkomsten till denna bil?",
        myAccessRemoved: "Åtkomst borttagen",
        noAdminsYet: "Inga administratörer har lagts till än.",
        adminInfoText: "Administratörer kan lägga till och redigera kostnader, anteckningar och reservdelar, men kan inte ta bort bilen själv.",
        newCar: "Lägg till bil",
        carNotFound: "Bilen hittades inte",
        carNotFoundDesc: "Den begärda bilen finns inte eller så har du inte åtkomst.",
        accessDenied: "Åtkomst nekad",
        accessDeniedDesc: "Denna bil är privat och inte offentligt tillgänglig.",
        backToHome: "Tillbaka till startsidan",
        adminRestricted: "Åtkomst begränsad",
        adminRestrictedDesc: "Endast auktoriserade administratörer kan få åtkomst till denna konsol. Vänligen återgå till huvudapplikationen.",
        returnHome: "Återgå hem",
        editCar: "Redigera bil",
        name: "Bilnamn",
        model: "Modell",
        year: "År",
        plate: "Registreringsnummer",
        vin: "VIN-nummer",
        mileage: "Aktuell körsträcka",
        initialMileage: "Initial körsträcka",
        engineType: "Motortyp",
        tapToChangeIcon: "Tryck för att ändra ikon",
        chooseIcon: "Välj ikon",
        imageTab: "Bild",
        iconTab: "Ikon",
        chooseColor: "Välj färg",
        chooseEmoji: "Välj emoji",
        uploadImage: "Ladda upp bild",
        clickToBrowse: "Klicka för att bläddra i filer",
        currentCarIcon: "Aktuell bilikon",
        changeImage: "Ändra bild",
        zoom: "Zooma",
        rotate: "Rotera",
        removeChangeImage: "Ta bort / Ändra bild",
        selectIcon: "Välj ikon",
        cropAndSave: "Beskär & Spara",
        displayName: "Visningsnamn",
        displayNamePlaceholder: "t.ex. Min helgbil",
        makeLabel: "Märke *",
        modelLabel: "Modell *",
        yearLabel: "År *",
        fuelTypeLabel: "Typ *",
        licensePlateLabel: "Registreringsskylt",
        vinLabel: "VIN",
        notesLabel: "Anteckningar (valfritt)",
        notesPlaceholder: "t.ex. 1.6 TDI, 85kW, 1588cc, batteri 62kWh, AWD, etc.",
        publicAccess: "Gör bilen offentligt tillgänglig",
        publicAccessDesc: "Andra kan se denna bil via delad länk",
        shareLocations: "Tillåt att visa även tillagda platser",
        shareLocationsDesc: "Aktivera detta för att göra bilens platser synliga i offentlig vy",
        deleteCar: "Ta bort bil",
        deleteCarTitle: "Ta bort bil",
        deleteCarConfirm: "Är du säker på att du vill ta bort '{name}'? Denna åtgärd kan inte ångras.",
        noCars: "Inga bilar i ditt garage",
        addFirstCarNote: "Börja din resa genom att lägga till ditt första fordon för att spåra kostnader.",
        addVehicle: "Lägg till ett fordon",
        myVehicles: "Mina fordon",
        favorites: "Favoriter",
        deleteConfirm: "Är du säker på att du vill ta bort denna bil? Alla associerade kostnader kommer att tas bort.",
        deleteFailed: "Misslyckades med att ta bort bilen",
        saveFailed: "Misslyckades med att spara bilinformation",
        adminActions: "Administratörsåtgärder",
        importCsv: "Importera CSV",
        clearData: "Rensa data",
        distanceUnitLabel: "Avståndsenhet",
        volumeUnitLabel: "Volymenhet",
        currencyLabel: "Valuta",
        boughtAt: "Köpedatum",
        purchasePrice: "Köpesumma",
        purchaseMileage: "Köpkörsträcka",
        createPurchaseRecord: "Skapa inköpshistorik automatiskt",
        makePlaceholder: "t.ex. BMW",
        modelPlaceholder: "t.ex. X5",
        platePlaceholder: "t.ex. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Denna information kommer att skapa en initial 'Information'-post i din historik med angivna data.",
        availableTypes: "Tillgängliga typer",
        dragToReorder: "Dra för att omordna",
        requestTypeNote: "Om du behöver en annan typ - ",
        requestTypeAction: "låt oss veta!",
        emailProcessingTitle: "E-postbehandling",
        emailInstructions: "Vidarebefordra dina kvitton till adressen nedan. Vi kommer att extrahera data och skapa kostnader automatiskt.",
        recentEmails: "Mottagna e-postmeddelanden",
        viewAllEmails: "VISA ALLA ({count})",
        noEmailsReceived: "Inga e-postmeddelanden har mottagits än.",
        analysisResult: "Analysresultat",
        vehicleInfo: "Fordoninformation",
        preferences: "Inställningar",
        purchaseHistory: "Inköpshistorik",
        emailProcessing: "E-postbehandling",
        publicAccessTitle: "Offentlig åtkomst",
        expenseTypesTitle: "Kostnadstyper",
        adminActionsTitle: "Administratörsåtgärder",
        enterPurchaseDateAlert: "Vänligen ange köpedatum",
        allowedSenderEmails: "Tillåtna avsändar-e-postadresser",
        allowedEmailsDesc: "Lägg till e-postadresser som är tillåtna att skicka kvitton till denna bil. Max 5 adresser.",
        noAllowedEmails: "Inga tillåtna e-postadresser har lagts till.",
        emailAlreadyAdded: "Denna e-postadress är redan tillåten för denna bil.",
        maxAllowedEmailsReached: "Maximalt antal tillåtna e-postadresser har nåtts.",
        addAllowedEmailPlaceholder: "Lägg till tillåten e-postadress...",
        ownerEmail: "Ägare",
        onlyOwner: "endast ägare",
        defaultAllowed: "Alltid tillåten",
        carLimitReachedTitle: "Bilgräns nådd",
        carLimitReachedMessage: "Din {plan}-plan tillåter {limit} bil(ar). Du har redan {current}. Gå till inställningar för att se dina gränser eller kontakta oss för att uppgradera.",
        carLimitGoToSettings: "Gå till inställningar",
        archivedCars: "Arkiverade",
        archiveCar: "Arkivera Bil",
        unarchiveCar: "Avarkivera Bil",
        sellDate: "Försäljningsdatum",
        sellPrice: "Försäljningspris",
        sellMileage: "Försäljningsmätare",
        archiveConfirm: "Är du säker på att du vill arkivera denna bil?",
        archiveInstructions: "Att arkivera en bil innebär att den inte längre är din eller att du inte längre underhåller den. Vänligen ange försäljningsdetaljer för statistik. Detta gör bilen skrivskyddad. Fälten nedan kan fortfarande redigeras efteråt.",
        archivedBadge: "Arkiverad",
        saleDetails: "Försäljningsdetaljer",
        saleDetailsNote: "Försäljningsdetaljer används för statistik. Du kan uppdatera dem om det behövs.",
        archiveDetailsNotFillable: "Vänligen fyll i alla fält för att arkivera bilen",
        emailAddressWillBeAvailableAfterSave: "E-postadress kommer att vara tillgänglig efter att bilen har sparats.",
        proFeatureAdminTitle: "Pro-funktion: Biladministratörer",
        proFeatureAdminDesc: "Lägg till andra användare som kan se och hantera dessa biluppgifter.",
        proFeatureEmailTitle: "Pro-funktion: Extra avsändare",
        proFeatureEmailDesc: "Lägg till andra tillåtna e-postadresser från vilka kvitton kan skickas till denna bil.",
        estimatedMileage: "Beräknad körsträcka",
        summaryFrequencyLabel: "Sammanfattningsfrekvens",
        summaryFrequencyOptions: {
            none: "Av",
            monthly: "Månatligen",
            semiAnnually: "Halvårsvis",
            annually: "Årligen",
        },
        healthProfilePrompt: "Fyll i din hälsoprofil för noggrann analys!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Bensin",
        diesel: "Diesel",
        hybrid: "Hybrid",
        electric: "El",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Miltrend",
        title: "Statistik",
        allYears: "Alla år",
        totalSpent: "Totalt Utgivet",
        spentIn: "Utgivet år {year}",
        perMonth: "per månad",
        overall: "totalt",
        vsPrev12m: "vs 12m f.",
        rolling12m: "Senaste 12m",
        byType: "Efter Typ",
        byMonth: "Efter Månad",
        byYear: "Efter År",
        noData: "Ingen data för detta år",
        mostExpensive: "Dyraste",
        top: "Topp",
        untitled: "Utan Titel",
        assetAnalysis: "Tillgångsvärde & Kostnadsanalys",
        burnNote: "* 'Total Burn' inkluderar både pengar som spenderats och den uppskattade minskningen i bilens värde.",
        carMarketValue: "Bilens Marknadsvärde",
        cumulativeCosts: "Kumulativa Kostnader",
        totalBurn: "Total Burn (Kostnader + Avskrivning)",
        entries: "poster",
        avgPrice: "Genomsnittligt Pris",
        consumption: "Förbrukning",
        price: "Pris",
        fuelPriceTrend: "Bränslepristrend",
        spendingTrend: "Utgiftstrend",
        costPerKmTrend: "Kostnad per 1 km",
        costPerMileTrend: "Kostnad per 1 mil",
        serviceTrendsTitle: "Service Trender",
        expensesOnMap: "Utgifter på Karta",
        visitsCountLabel: "besök",
        locationsSummary: "Sammanfattning av Platser",
        locationsCountLabel: "platser",
        noLocationsFoundTitle: "Inga platser ännu",
        noLocationsFoundDesc: "Lägg till platser i dina register för att se dem på kartan.",
        addMileageData: "Lägg till körsträcka",
        missingMileageInfo: "Inte tillräckligt med data för att beräkna kostnad per avstånd. Lägg till minst 2 körsträckor under denna period (eller en före denna period).",
        mileageModal: {
            title: "Lägg till saknad körsträcka",
            description: "För att noggrant beräkna kostnader per avstånd för {year}, behöver vi veta körsträckan i början och slutet av året.",
            startOfYear: "Början av året (1 jan)",
            endOfYear: "Slutet av året (31 dec)",
            currentMileage: "Aktuell körsträcka",
            placeholder: "Ange körsträcka...",
            save: "Spara data",
            foundNearby: "Hittad i närheten ({date}): {value} {unit}",
            useExisting: "Använd detta",
        },
        proAnalysis: "Pro-analys",
        detailedAnalysis: "Detaljerad analys",
        upgradeToSee: "Uppgradera för att se →",
    },
    tabs: {
        dashboard: "Instrumentpanel",
        expenses: "Utgifter",
        stats: "Statistik",
        locations: "Platser",
        gallery: "Filer",
        parts: "Delar",
        notes: "Anteckningar",
        repair: "Reparationsläge",
        'repair-switch': "Bilbyte",
    },
    repairAnalysis: {
        title: "Reparationsbeslutsanalys",
        ownershipLength: "Ägande längd",
        currentValue: "Nuvarande Värde",
        valueOutdated: "Värdet kan vara föråldrat",
        addValueToEnable: "Lägg till nuvarande bilvärde för att aktivera analys",
        totalInvested: "Totalt Investera",
        totalInvestedSub: "Inköpspris + reparationer",
        totalExcludesFuel: "exkluderar bränsle / elektricitet",
        fuelLabelFuelOnly: "Bränsle totalt",
        fuelLabelEnergyOnly: "Energi totalt",
        fuelLabelHybrid: "Bränsle & Energi totalt",
        fuelTypeFuel: "bränsle",
        fuelTypeEnergy: "elektricitet",
        fuelTypeHybrid: "bränsle & elektricitet",
        fuelTotalLabel: "Bränsle/Energi totalt:",
        projectionMode: "Projekteringsläge",
        projectionModes: {
            lastYear: "Baserat på förra året",
            average: "Historiskt genomsnitt",
            trend: "Trendande (linjär)",
        },
        brakeAssumption: "Underhåll inkluderar uppskattad 3-årig bromscykel",
        repairBuffer: "Inkluderar åldersbaserat reparationsriskbuffert",
        yearLabel: "år",
        totalInvestedDesc: "Inköpspris + alla reparationer",
        repairToValue: "Reparera till Värde (12m)",
        repairToValueExplain: "Reparationer €{cost} vs bilvärde €{value}. Under 20% är hälsosamt; över 50% är hög risk.",
        ownershipPressure: "Ägandepress",
        ownershipPressureExplain: "Totalt kostnadstryck: reparationer €{cost} + värdeförlust vs €{value}. Över 35% signalerar finansiell stress.",
        investmentGap: "Investeringsgap",
        investmentGapExplain: "Totalt investerat €{invested} minus nuvarande värde €{value}. Detta visar hur mycket du har 'förlorat' på ägande hittills.",
        investmentGapDesc: "Totalt investerat - nuvarande värde",
        repairExpenses12m: "12m Reparationskostnad",
        calculatedYearlyMileage: "Beräknad årlig körsträcka: {km} km",
        calculatedYearlyRepairs: "Beräknade årliga reparationer: {amount}",
        set: "Ställ in",
        plannedRepairCost: "Planerad reparationskostnad",
        whatIfTitle: "Vad om du spenderar {amount} nu?",
        updatedScore: "Uppdaterad poäng",
        updatedVerdict: "Uppdaterad bedömning",
        howIsItCalculated: "Hur beräknas detta?",
        usedLifespan: "Använd: {usage}% av förväntad livslängd",
        remainingLifespan: "Återstående: ~{km} km",
        estimatedLifespan: "Uppskattad livslängd: {km} km",
        lifecycle_stage_early: "Tidigt livscykel – låg risk för stora fel",
        lifecycle_stage_mid: "Mitten av livscykel – normalt slitage",
        lifecycle_stage_late: "Sent livscykel – ökad risk för reparationer",
        lifecycle_stage_end: "Slut på förväntad livslängd – hög risk för stora reparationer",
        calculationExplanation: "Analysen använder ditt fordons inköpspris, senaste reparationskostnader och uppskattat nuvarande värde för att beräkna en finansiell hälsopoäng. Höga reparationskostnader i förhållande till bilens värde eller snabb avskrivning kommer att sänka poängen.",
        confidenceLabel: "Förtroende",
        confidenceLevel: {
            high: "Hög",
            medium: "Medel",
            low: "Låg",
        },
        mentalFactorsTitle: "Förbättra noggrannheten med din erfarenhet",
        mentalFactorsCTA: "Snabb kontroll (30 sek)",
        mentalFactorsSurveyTitle: "Din Erfarenhet",
        mentalFactorsSurveyDesc: "Svara på 3 snabba frågor för att anpassa din poäng.",
        q1: "Möter din bil dina behov?",
        q1Help: "Utrymme, komfort, funktioner",
        q2: "Tycker du om att köra din bil?",
        q2Help: "Visuellt, komfort, känsla",
        q3: "Oroar du dig för oväntade haverier?",
        q3Help: "Tillförlitlighetsbekymmer",
        q4: "Är denna bil för familj och långresor?",
        q4Help: "Säkerhet och tillförlitlighet prioritet",
        factorsTitle: "Poängfaktorer",
        factorsDesc: "Se vad som påverkar din poäng",
        newCarComparison: "Jämförelse av Ny Bil",
        newCarComparisonDesc: "Jämför din nuvarande månadskostnad med att köpa en ny bil.",
        modeLeasing: "Leasing",
        modeFullPrice: "Fullt pris",
        downPayment: "Handpenning",
        leaseYears: "Löptid (År)",
        monthlyPayment: "Månadskostnad",
        carPrice: "Bilens fulla pris",
        ownershipYears: "Planerad ägande (År)",
        insuranceMonthly: "Månatlig CASCO / Försäkring",
        currentMonthlyCost: "Nuvarande bilkostnad",
        newCarMonthlyCost: "Kostnad för ny bil",
        newCarCheaper: "Ny bil är billigare med: {amount} / mån",
        newCarMoreExpensive: "Ny bil är dyrare med: {amount} / mån",
        newCarSameCost: "Kostnaderna är exakt desamma.",
        advancedSettings: "Avancerade inställningar",
        yearlyMaint: "Årlig underhåll (€)",
        tyres3Yrs: "Däck / 3 år (€)",
        depreciation5Yrs: "Avskrivning (5 år %)",
        newCarYear: "Ny bil år",
        cumulativeCosts: "Kumulativa kostnader (Projektion)",
        comparisonByYear: "Jämförelse per år",
        currentCarLabel: "Nuvarande bil",
        newCarLabel: "Ny bil",
        resaleValue: "Andrahandsvärde",
        startupCosts: "Startkostnader (Begagnad bil)",
        inspection: "Förhandsinspektion",
        initialMaintenance: "Initial underhåll + oljor",
        registration: "Registrering / Avgifter",
        total: "Totalt",
        currentCarTitle: "Nuvarande bil",
        newCarTitle: "Potentiell bil",
        upfrontInvestment: "Första investering",
        monthlyReality: "Verklig månadskostnad",
        depreciationShort: "Avskrivning",
        howCalculated: "Hur beräknas detta?",
        deltaMonthly: "Månatlig skillnad",
        deltaUpfront: "Första skillnad",
        surveyMeanings: {
            practical: {
                1: "Inte alls",
                2: "Dålig passform",
                3: "Genomsnittlig",
                4: "Bra passform",
                5: "Perfekt passform",
            },
            joy: {
                1: "Frustrerande",
                2: "Tråkig",
                3: "Genomsnittlig",
                4: "Trevlig",
                5: "Mycket",
            },
            worry: {
                1: "Inte orolig",
                2: "Lite orolig",
                3: "Orolig",
                4: "Mycket orolig",
                5: "Säker på att jag kommer att få motorstopp när som helst",
            },
        },
        verdicts: {
            KEEP: "Ekonomiskt rimligt att behålla",
            borderline: "Gränsfall – övervaka noga",
            sell: "Hög finansiell risk – försäljning kan vara rationell",
        },
        factors: {
            trendInc: "Ökande trend",
            trendIncDesc: "Reparationskostnaderna ökar jämfört med förra året.",
            lowDepreciation: "Fördel med låg avskrivning",
            lowDepreciationDesc: "Äldre/billigare bilar tappar mindre värde över tid.",
            stableRepairs: "Stabila reparationer",
            stableRepairsDesc: "Dina reparationskostnader är stabila eller minskande.",
            noHistoricalData: "Ingen data äldre än 6 månader.",
            lifecycle_stage: "Fordonets livscykelstadium",
            high_risk_phase: "Hög-riskfas",
            high_risk_phase_desc: "Kombinationen av ett sent livscykelstadium och ökande reparationskostnader indikerar hög risk.",
            lowCostKm: "Effektiv kostnad per km",
            lowCostKmDesc: "Den övergripande effektiviteten av att köra denna bil är utmärkt.",
            lowFixedCosts: "Låga fasta kostnader",
            lowFixedCostsDesc: "Dina fasta kostnader (skatter, försäkring) är låga.",
            usage: "Årlig användning",
            usageDesc: "Körsträcka under de senaste 12 månaderna.",
            accidentMinor: "Mindre olycka",
            accidentMinorDesc: "Kosmetiska skador eller små reparationer.",
            structuralDamage: "Strukturell skada",
            structuralDamageDesc: "Ram- eller strukturella problem sänker värdet drastiskt.",
            aiLifespanNearEnd: "Slut på förväntad livslängd",
            aiLifespanAging: "Åldrande komponenter",
            aiLifespanGood: "Fördel med låg körsträcka",
            aiLifespanDesc: "Baserat på AI's uppskattade typiska livslängd för denna modell.",
            aiUpcomingRepairs: "Kommande reparationer (AI förutsägning)",
            aiUpcomingRepairsDesc: "AI förutspår stora komponenthaverier snart baserat på körsträcka.",
            ownershipFatigue: "Ägandetrötthet",
            ownershipFatigueLong: "Långsiktigt ägande leder ofta till mental beredskap för ett annat fordon.",
            ownershipFatigueShort: "Initial ägarbias skapar en starkare tendens att behålla bilen.",
            family_priority: "Familj & Långresor",
            replacement_comparison: "Ersättningsjämförelse",
            none: "Ingen",
            surface: "Yta",
            minor: "Mild",
            moderate: "Måttlig",
            severe: "Allvarlig",
            structural: "Strukturell",
            major: "Större",
            critical: "Kritisk",
            full: "Full",
            improveLabel: "Vad skulle förbättra detta:",
            info_original_price: "Det ungefärliga priset för denna bil när den var ny. Hjälper till att uppskatta värdestabilitet. Äldre bilar med lägre kvarvarande värde är säkrare ekonomiskt.",
            info_current_value: "Hur mycket du skulle kunna sälja den för idag. Används för att kontrollera om reparationer är en stor procentandel av bilens värde, vilket signalerar dålig investering.",
            info_yearly_mileage: "Högre körsträcka ökar slitage. Låg körsträcka kan avsevärt förlänga bilens livslängd.",
            info_estimated_repairs: "Löpande kostnad för att hålla bilen i drift. Höga årliga kostnader minskar attraktiviteten av att behålla bilen.",
            info_planned_repairs: "Kända kommande reparationer. Simulerar omedelbart tryck på ditt beslut.",
            info_ownership_years: "Hur länge har du ägt denna bil? Detta påverkar psykologisk ägandetrötthet och initial köparbias.",
            info_rust: "Kritisk långsiktig risk. Strukturell rost minskar säkerheten. Svår rost gör försäljning till ett bättre alternativ.",
            info_crashes: "Strukturella olyckor påverkar säkerhet och tillförlitlighet. De minskar också andrahandsvärdet avsevärt.",
            info_repaint: "Signaliserar tidigare skador eller kosmetiska reparationer. Liten påverkan om inte djupare problem dolts.",
            info_unresolved: "Dolda framtida kostnader. Kända fel i elektronik, motor eller underhåll som behöver uppmärksamhet.",
            info_fit: "Passar bilen dina behov (utrymme, komfort)? En dålig passform innebär att du är mer benägen att byta ut den.",
            info_joy: "Emotionellt värde spelar roll. Ingen glädje betyder att du mentalt är redo för en ny bil.",
            info_worry: "Upplevd tillförlitlighetsstress. Hög oro är en stark signal att byta bilen.",
        },
        explanations: {
            repairFreq: "Din bil hade {visits} servicebesök under de senaste 12 månaderna. Frekventa besök indikerar lägre tillförlitlighet och högre besvär.",
            repairVsValue: "Under de senaste 12 månaderna kostade dina reparationer €{cost}, medan bilens uppskattade värde är €{value}. Det är {ratio}% av bilens totala värde.",
            stableRepairsDetailYearly: "Förra året spenderade du €{cost1} på reparationer, men året innan €{cost2}. Förändring av {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "De senaste 6 månaderna spenderade du €{cost1}, föregående 6 månader €{cost2}. Förändring av {percent}% ({trend}).",
            mileage: "Vid {mileage} km går bilen in i en högre riskzon för större delhaverier (växellåda, motor komponenter).",
            planned: "Du har €{cost} i planerade reparationer, vilket omedelbart minskar den finansiella säkerheten för att behålla bilen.",
            lowDep: "Bilar värderade runt €{value} tappar mycket lite värde per år, vilket motverkar högre reparationskostnader.",
            depRisk: "Din bil är {age} år gammal och har mestadels avslutat sin avskrivningscykel, vilket innebär att du inte förlorar pengar på att värdet sjunker.",
            stable: "Du spenderade €{costThisYear} i år jämfört med €{costLastYear} förra året, vilket är en minskning på {percent}%. Förutsägbara kostnader är matematiskt fördelaktiga.",
            costKm: "Du körde {km} km förra året. Driftskostnaderna var €{costKm} per kilometer, vilket visar utmärkt ekonomisk effektivitet.",
            fixedCosts: "Du betalade €{costs} i fasta årliga kostnader (försäkring/skatt). Detta låga fotavtryck ger extra sinnesro.",
            usage: "Du kör omkring {km} km per år baserat på dina loggar.",
            practical_fit: "Du utvärderade den praktiska passformen till {score}/5, vilket justerade den matematiska poängen med {impact} poäng.",
            emotional_satisfaction: "Du utvärderade din emotionella tillfredsställelse till {score}/5, vilket justerade poängen med {impact} poäng.",
            reliability_anxiety: "Din tillförlitlighetskonfidence är {score}/5, vilket påverkar poängen med {impact} poäng.",
            rust: "Allvarlig strukturell eller underkroppsrost innebär vanligtvis säkerhetsrisker eller avskrivningsscenarier.",
            accident: "Tidigare skador, beroende på svårighetsgrad, minskar i grunden fordonets andrahandsvärde och säkerhet.",
            structural: "Strukturella problem gör bilen ekonomiskt farlig.",
            ai_lifespan: "Vid {current} km har bilen genomfört {ratio}% av sin AI-beräknade livslängd ({expect} km).",
            ai_repairs: "AI-data visar att {count} typiska modell-specifika större reparationer tenderar att inträffa vid denna körsträcka.",
            lifecycle_stage: "Vad betyder livslängd? {total} km – detta är den AI-predikterade punkten när större strukturella reparationer (motor, växellåda, etc.) vanligtvis börjar för denna modell. Det är inte slutet på bilens liv – bilen kan fortfarande köra, men med betydligt högre underhållskostnader. En typisk bils fulla fysiska livslängd är 500k–1M km, men den blir ekonomiskt olönsam mycket tidigare.",
        },
        ratios: {
            healthy: "Frisk",
            monitor: "Övervaka",
            highRisk: "Hög risk",
            stable: "Stabil",
            warning: "Varning",
            financialStress: "Ekonomisk stress",
        },
        proFeatureTitle: "Pro-funktion: Reparationsläge",
        proFeatureDesc: "Lås upp beslutsmotorn för att få en professionell ekonomisk analys av dina fordonsreparationer. Gratisanvändare ser en demonstration med exempeldata.",
        viewDemo: "Se Live Demo",
        upgradeToUnlock: "Uppgradera till PRO för att analysera din bil",
    },
    carTasks: {
        title: "Biluppgifter",
        placeholderTitle: "Underhållsspårning",
        placeholderDesc: "Underhållsschema för din bilmodell.",
        demoTitle: "Bilunderhållsuppgifter",
        demoSubtitle: "Smart spårning för ditt fordon",
        feature1Title: "Automatiserad Uppgiftsgenerering",
        feature1Desc: "Genererar automatiskt uppgifter som oljebyten, filterbyten och kamremkontroller baserat på din bils modell.",
        feature2Title: "Kostnadsintegration",
        feature2Desc: "Analyserar din servicehistorik för att förstå vad som redan har gjorts och när.",
        feature3Title: "Smart Påminnelser",
        feature3Desc: "Få meddelanden baserat på både tid och körsträcka. Spårningen återställs automatiskt när du markerar en uppgift som klar.",
        getStarted: "Kom igång",
        fakeDoorPopupTitle: "Feedback Välkommen",
        fakeDoorPopupMessage: "Vi utvecklar för närvarande bilunderhållsuppgifter. Denna funktion kommer att låta dig spåra serviceintervall automatiskt. Vilka specifika uppgifter eller funktioner skulle du vilja se mest?",
        fakeDoorPopupPlaceholder: "Dina tankar...",
        noTasksYet: "Inga uppgifter ännu",
        deleteAllTitle: "Rensa uppgiftslista?",
        deleteAllMessage: "Är du säker på att du vill radera alla {count} uppgifter för denna bil? Denna åtgärd kan inte ångras.",
        deleteAllSuccess: "Alla uppgifter har raderats framgångsrikt.",
        sortPriority: "Prioritet",
        sortType: "Typ",
        sortDate: "Senaste",
        status: {
            overdue: "FÖRSENAD",
            pending: "VÄNTAR",
            noData: "INGA DATA",
            upcoming: "Kommande",
            nextIn: "Nästa om {dist} {unit}",
            overdueBy: "{dist} {unit} försenad",
            afterDays: "Om {days} dagar",
            overdueDays: "{days} dagar försenad",
        },
        form: {
            newTitle: "Ny Uppgift",
            actionType: "Inspektera eller Byta?",
            intervalMonths: "Intervall (Månader)",
            intervalDistance: "Intervall (Avstånd)",
            diffFirstInterval: "Första intervallet skiljer sig från basintervallet",
            firstInterval: "Första Intervall",
            historyToggle: "Har denna uppgift någonsin utförts för denna bil?",
            historyToggleDesc: "Om NEJ, antar vi att det aldrig har gjorts sedan produktionen.",
            lastPerformedOptional: "När utfördes den senast? (Valfritt)",
            deleteTitle: "Radera Uppgift",
            deleteConfirm: "Är du säker på att du vill radera denna uppgift?",
            saveError: "Misslyckades med att spara uppgift",
            historyConfirmed: "Historik Bekräftad",
            reminders: "Påminnelser",
            notifyMileage: "Meddela mig när uppskattad körsträcka nås",
            notifyDate: "Meddela mig när datumet nås",
            nextMileageReminder: "Uppskattat datum",
            nextDateReminder: "Förfallodatum",
            estimatedDate: "Beräknat datum",
            missingLastMileage: "Saknar senaste körsträcka",
            missingLastDate: "Saknar senaste datum",
            missingStartDate: "Kunde inte bestämma startdatum",
            additionalOptions: "Ytterligare alternativ",
            reminderInfoMissing: "Informationsstatus: påminnelser är inaktiverade tills senaste utförda data tillhandahålls.",
        },
    },
    dashboard: {
        title: "Instrumentbräda",
        quickActions: "Snabba åtgärder",
        addExpense: "Lägg till utgift",
        editCar: "Redigera bil",
        recentExpenses: "Utgifter",
        seeAll: "Se alla",
        recentGallery: "Filer",
        thisMonth: "Denna månad",
        totalSpent: "Totalt spenderat",
        avgPerMonth: "Genomsnitt/månad",
        recentNotes: "Anteckningar",
        recentParts: "Delar",
        noRecentExpenses: "Inga senaste utgifter",
        noRecentGallery: "Inga senaste foton",
        noRecentNotes: "Inga senaste anteckningar",
        noRecentParts: "Inga senaste delar",
        createNote: "Skapa ny",
        createPart: "Skapa ny",
        createExpense: "Skapa ny",
        noFiles: "Inga filer tillagda ännu",
        needSomethingMore: "Behöver du något mer?",
        letUsKnow: "låt oss veta!",
    },
    expenseTypes: {
        editTitle: "Redigera utgiftstyp",
        newTitle: "Ny utgiftstyp",
        categoryName: "Kategorinamn",
        placeholderName: "t.ex. Service",
        signatureColor: "Signaturfärg",
        icon: "Kategoriikon",
        deleteConfirm: "Är du säker på att du vill ta bort typ '{name}'?",
    },
    spareParts: {
        title: "Reservdelar",
        connectedWithRecords: "Ansluten med poster",
        toBuy: "Att köpa",
        usedInExpenses: "Används i utgifter",
        noPartsToBuy: "Inga delar tillagda till inköpslistan",
        noPartsUsed: "Inga delar kopplade till utgifter ännu",
        quantity: "Antal",
        partCode: "Delkod",
        price: "Pris",
        link: "Länk",
        comment: "Kommentar",
        addPart: "Lägg till reservdel",
        editPart: "Redigera reservdel",
        openPart: "Öppna delinmatning",
        nameLabel: "Namn",
        manufacturerLabel: "Tillverkare",
        priceLabel: "Pris ({currency})",
        imagesLabel: "Filer",
        linkedHistory: "Kopplad historia",
        partManagedNote: "Denna del hanteras genom en utgift",
        cannotDeleteNote: "Eftersom denna del är kopplad till en utgift kan den inte tas bort separat. Ta bort eller redigera utgiften för att hantera denna dels livscykel.",
        partNamePlaceholder: "Delens namn...",
        manufacturerPlaceholder: "Bosch, Brembo, etc.",
        additionalInfoPlaceholder: "Ytterligare information...",
        namePlaceholder: "t.ex. Bromsbelägg",
        codePlaceholder: "t.ex. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Spara del",
        deletePart: "Ta bort reservdel",
        deleteConfirm: "Är du säker på att du vill ta bort denna reservdel?",
        sparePartsLabel: "Reservdelar",
        partNumber: "Del #{number}",
        imagesLimitLabel: "Filer (upp till 5)",
        optional: "(valfritt)",
        selectPart: "Välj reservdel",
        createNew: "Skapa ny reservdel",
        searchPlaceholder: "Sök efter namn eller kod...",
        noResults: "Inga delar hittades",
        noPartsYet: "Inga delar ännu. Skapa din första!",
        selectorDescription: "Hitta och välj en befintlig reservdel, eller skapa en ny",
        alreadyAdded: "Denna del är redan tillagd",
        statistics: {
            avgPrice: "Genomsnitt",
            lastPrice: "Senaste",
            usedTimes: "Använd {count} gånger",
            totalPurchased: "Totalt: {quantity}x",
        },
        usage: {
            title: "Detta köp",
            quantity: "Antal",
            pricePerUnit: "Pris per enhet",
            comment: "Kommentar",
            commentPlaceholder: "t.ex. Köpt på AutoZone",
            total: "Totalt",
            transactionData: "Denna Transaktion",
        },
        masterData: "Huvuddel Info",
        masterRecord: {
            title: "Delinformation (delad)",
            editMaster: "Redigera huvudpost",
            warning: "Ändringar i huvudposten påverkar alla användningar",
        },
    },
    reminders: {
        title: "Påminnelser",
        reminder: "Påminnelse",
        noteReminder: "Notera Påminnelse",
        partReminder: "Del Påminnelse",
        today: "Idag",
        tomorrow: "Imorgon",
        yesterday: "Igår",
        inXDays: "om {x} dagar",
        xDaysAgo: "för {x} dagar sedan",
        inXMonths: "om {x} månader",
        xMonthsAgo: "för {x} månader sedan",
        active: "Aktiv",
        activeDesc: "Om nödvändigt kan du stänga av denna påminnelse utan att radera den",
        disabled: "Inaktiverad",
        yearly: "Årligen",
        markSeen: "Bekräfta",
        addReminder: "Ny Påminnelse",
        editReminder: "Redigera Påminnelse",
        extraReminders: "Extra Påminnelser",
        extraRemindersDesc: "Skicka 3 ytterligare påminnelser på följande dagar (totalt 4) om det inte stoppas.",
        remindDate: "Datum",
        remindTime: "Tid",
        repeatYearly: "Upprepa Årligen",
        repeatYearlyDesc: "Denna påminnelse kommer automatiskt att inträffa varje år på samma datum/månad/dag/tid tills den inaktiveras",
        standalone: "Fristående Påminnelser",
        embedded: "Länkade Påminnelser",
        noReminders: "Inga aktiva påminnelser",
        deleteReminder: "Radera Påminnelse",
        nameLabel: "Namn",
        descriptionLabel: "Beskrivning",
        namePlaceholder: "Påminnelse namn",
        descriptionPlaceholder: "Kort beskrivning eller anteckning",
        simulateReminder: "Simulera påminnelse ögonblick",
        simulateSuccess: "Simulerings-e-post skickad",
        timezone: "Tidszon",
        nextReminder: "Nästa påminnelse",
        futureTimeError: "Påminnelse tiden måste vara i framtiden",
    },
    notes: {
        title: "Anteckningar",
        emptyNote: "Tom anteckning",
        noNotes: "Inga anteckningar ännu",
        addNote: "Lägg till anteckning",
        editNote: "Redigera anteckning",
        viewNote: "Visa anteckning",
        openNote: "Öppna anteckningsinmatning",
        titleLabel: "Titel",
        contentLabel: "Innehåll",
        noteTitlePlaceholder: "Anteckningens titel...",
        noteContentPlaceholder: "Skriv din anteckning här...",
        saveNote: "Spara anteckning",
        deleteNote: "Ta bort anteckning",
        publicNote: "Gör anteckningen offentlig",
        publicNoteDesc: "Andra kan se denna anteckning via delad länk",
        deleteConfirm: "Är du säker på att du vill ta bort denna anteckning?",
        enterTitleAlert: "Vänligen ange en titel",
        saveFailed: "Misslyckades med att spara anteckning",
        thisNote: "Denna anteckning",
        deleteFailed: "Misslyckades med att ta bort anteckning",
        pinToTop: "Fäst högst upp",
    },
    locations: {
        title: "Platser",
        singleTitle: "Plats",
        newLocation: "Ny plats",
        emptyLocation: "Tom plats",
        noLocations: "För statistik - du kan lägga till platsen där denna bilkostnad inträffade",
        addLocation: "Lägg till plats",
        editLocation: "Redigera plats",
        viewLocation: "Visa plats",
        openLocation: "Öppna plats",
        createNew: "Skapa ny plats",
        selectLocation: "Välj plats",
        searchLocations: "Sök platser...",
        nameLabel: "Namn",
        addressLabel: "Adress eller koordinater",
        descriptionLabel: "Kommentar/Beskrivning",
        namePlaceholder: "t.ex. Centrumservice",
        mapLabel: "Plats",
        searchPlaceholder: "Sök adress...",
        addressPlaceholder: "Ange adress och välj...",
        descriptionPlaceholder: "Ytterligare info...",
        fillAddress: "Fyll i adress från karta",
        saveLocation: "Spara plats",
        deleteLocation: "Ta bort plats",
        deleteConfirm: "Är du säker på att du vill ta bort denna plats?",
        enterNameAlert: "Vänligen ange ett namn",
        saveFailed: "Misslyckades med att spara plats",
        thisLocation: "Denna plats",
        deleteFailed: "Misslyckades med att ta bort plats",
        myLocations: "Mina platser",
        usedInEntries: "Används i poster",
        noEntries: "Platsen används inte",
        noEntriesThisCar: "Denna plats har inte använts för denna bil",
        removeLocation: "Ta bort plats",
        noResults: "Inga resultat hittades",
    },
    gallery: {
        title: "Filer",
        noImages: "Inga bilder tillagda",
        addImagesNote: "Lägg till bilder på bil eller kostnader",
        totalImages: "Totalt {count} bilder",
        imageAlt: "Bild {number}",
        commentPlaceholder: "Filkommentar",
        isReceipt: "Denna fil är ett kvitto",
        deleteImageTitle: "Ta bort fil",
        deleteImageConfirm: "Är du säker på att du vill permanent ta bort denna fil?",
    },
    search: {
        placeholder: "Sök kostnader, delar, anteckningar...",
        typeToSearch: "Skriv för att börja söka",
        noResults: "Inga resultat hittades för '{query}'",
        carImage: "Bilbild",
        expenseImage: "Kostnadsbild",
        noteImage: "Anteckningsbild",
        galleryImage: "Galleri bild",
        untitledExpense: "Utan titel kostnad",
    },
    landing: {
        nav: {
            features: "Funktioner",
            howItWorks: "Hur det fungerar",
            pricing: "Prissättning",
            login: "Logga in",
            getStarted: "Kom igång",
            garage: "Garage",
        },
        hero: {
            title: "Vet Exakt Vad Din Bil",
            subtitle: "Verkligen Kostar",
            description: "Håll koll på utgifter, logga reparationer och se vart dina pengar verkligen går.",
            subheadline: "Den professionella datadrivna instrumentpanelen för noggranna bilägare.",
            startTracking: "Börja",
            viewDemo: "Demo Bil ->",
            trustSignal: "Gå med i 1 200+ noggranna ägare som redan har kartlagt över 5 miljoner kilometer av verkliga bilkostnader.",
            ctaNote: "Ingen kreditkort. Ingen påträngande försäljning. Bara klarhet.",
            benefits: {
                repairVsSell: {
                    title: `Reparera vs. Sälja`,
                    description: `Se "Reparera vs. Sälja" tröskeln — Sluta undra om du slänger pengar i en pengagrop. Känn det exakta ögonblicket en reparation inte längre är en smart investering.`
                },
                costPerKm: {
                    title: `Kostnad-per-KM`,
                    description: `Håll koll på din verkliga kostnad-per-kilometer — Gå bortom instrumentpanelen. Se hela den ekonomiska bilden av dina körvanor som andra appar lämnar ut.`
                },
                automation: {
                    title: `Automatisering`,
                    description: `Automatisera din bokföring — Skicka bara vidare dina fakturor eller maila dina anteckningar. Vår AI organiserar din bils tekniska historia åt dig.`
                }
            },
        },
        features: {
            title: "Allt du behöver för att hantera din bil",
            subtitle: "Sluta använda kalkylblad och röriga mappar. My Car Costs ger professionella verktyg för flottahantering till ditt personliga garage.",
            expenseTracking: {
                title: "Kostnadsspårning",
                description: "Logga bränsle, service, försäkring och reparationer. Kategorisera kostnader och visualisera utgiftsmönster över tid.",
            },
            spareParts: {
                title: "Reservdelsförvaltare",
                description: "Håll en detaljerad inventering av reservdelar, delnummer och kompatibilitetsnoteringar för alla dina reparationer.",
            },
            serviceHistory: {
                title: "Servicehistorik & Anteckningar",
                description: "Underhåll en digital servicebok. Lägg till detaljerade anteckningar om underhåll, modifieringar eller framtida planer.",
            },
            documentStorage: {
                title: "Dokumentlagring",
                description: "Ladda upp kvitton, fakturor och foton av din bil. Håll all din dokumentation säker och tillgänglig.",
            },
            emailForwarding: {
                title: "E-post vidarebefordran",
                description: "Vidarebefordra fakturor direkt till din unika inkorg. Vi extraherar datan och lägger till den på din instrumentpanel automatiskt.",
            },
            multiCar: {
                title: "Flera bilar garage",
                description: "Hantera en bil eller en hel flotta. Växla mellan fordon omedelbart och se aggregerad statistik.",
            },
            repeatingExpenses: {
                title: "Återkommande utgifter",
                description: "Automatisera spårning av regelbundna månatliga kostnader som försäkring, parkering eller leasing.",
            },
            smartReminders: {
                title: "Smart påminnelser",
                description: "Ställ in anpassade aviseringar för reservdelar och serviceanteckningar för att aldrig missa en underhållsuppgift.",
            },
        },
        howItWorks: {
            title: "Enkel, kraftfull arbetsflöde",
            step1: {
                title: "Lägg till ditt fordon",
                description: "Ange dina biluppgifter för att skapa ditt digitala garage.",
            },
            step2: {
                title: "Logga kostnader & filer",
                description: "Ta en bild av ett kvitto eller vidarebefordra ett e-postmeddelande. Vi hanterar resten.",
            },
            step3: {
                title: "Få insikter",
                description: "Se dina kostnader per kilometer, månatliga utgifter och underhållstidslinje.",
            },
        },
        useCases: {
            title: "Perfekt för",
            enthusiasts: {
                title: "Bilentusiaster",
                description: "Spåra varje modifiering, delnummer och underhållsintervall för din projektbil.",
            },
            dailyDrivers: {
                title: "Dagliga förare",
                description: "Veta exakt hur mycket din pendling kostar och missa aldrig ett servicetid.",
            },
            flippers: {
                title: "Den Smart Flippare",
                description: "Bygg en verifierbar mängd data som bevisar din bils verkliga värde för köpare.",
            },
            fleets: {
                title: "Små flottor",
                description: "Hantera flera företagsfordon på ett ställe utan företagsprogramvarans överflöd.",
            },
        },
        foundersNote: {
            title: "Grundarens Not",
            content: "Jag bygger MyCarCosts för att vara det ultimata verktyget för människor som verkligen bryr sig om sina bilar. Finns det en funktion som saknas i ditt arbetsflöde? Kontakta mig direkt. Om det är meningsfullt för gemenskapen, bygger vi det tillsammans.",
        },
        pricing: {
            freeLimitedTime: "Gratis under en begränsad tid",
            title: "Enkel, transparent prissättning",
            subtitle: "Börja gratis, uppgradera när du växer.",
            perMonth: "månad",
            monthly: "Månatlig",
            yearly: "Årlig",
            save25: "Spara 25%",
            billedAnnually: "Faktureras årligen ({amount})",
            free: {
                title: "Gratis",
                cta: "Kom igång",
            },
            pro: {
                title: "Pro",
                cta: "Uppgradera till Pro",
                recommended: "Rekommenderad",
                earlyAdopter: "Prissättning för tidiga användare",
                priceLock: "Säkra detta pris nu. Priset kan öka i framtiden.",
            },
            custom: {
                title: "Custom",
                cta: "Kontakta oss",
            },
            features: {
                oneCar: "1 bil",
                unlimitedExpenses: "Obegränsade utgifter",
                unlimitedSpareParts: "Obegränsade reservdelar",
                unlimitedNotes: "Obegränsade anteckningar",
                repeatedExpenses: "Återkommande utgifter",
                emailReminders: "Anteckningar och reservdelar e-postpåminnelser",
                basicStatistics: "Grundläggande statistik",
                fullStatistics: "Fullständig statistik",
                storage50mb: "50 Mb filutrymme",
                unlimitedArchivedCars: "Obegränsade arkiverade bilar",
                dataExport: "Dataexport",
                allInFreePlus: "allt i gratis plus:",
                threeCars: "Upp till 3 bilar",
                storage2gb: "2 Gb filutrymme",
                emailParsing: "E-postanalys",
                carAdmins: "Biladministratörer",
                moreCars: "Fler bilar",
                moreFileStorage: "Mer filutrymme",
                customRequirements: "Anpassade krav",
            },
            upgradePopup: {
                title: "Kommer snart!",
                message: "Pro- och anpassade versioner har ännu inte lanserats, men de kommer snart. För att hjälpa oss att lansera snabbare - vänligen skriv ner vilken specifik funktion du förväntar dig från pro / anpassad version, eller något annat du vill att vi ska förbättra för att göra denna plattform ännu bättre för dig!",
                placeholder: "Skriv din feedback här...",
                submit: "Skicka",
                cancel: "Avbryt",
                thanksTitle: "Tack!",
                thanksMessage: "Vi har mottagit din feedback och kommer att arbeta för att göra MyCarCosts ännu bättre!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Flyttar du från Excel eller en annan app?",
            subtitle: "Vi erbjuder en professionell datamigrationsservice för att få dig igång direkt.",
            pricingModel: "Prismodell",
            small: {
                title: "Litet dataset",
                description: "< 500 rader",
                price: "19–29 kr",
            },
            medium: {
                title: "Medelstort dataset",
                description: "500–5 000 rader",
                price: "49 kr",
            },
            large: {
                title: "Stort / Rörigt",
                description: "Äldre system eller komplexa filer",
                price: "Anpassad offert",
            },
            process: {
                title: "Så här fungerar det",
                step1: "Du skickar in din fil",
                step2: "Vi utvärderar datan",
                step3: "Engångsbetalning",
                step4: "Vi hanterar importen",
            },
            cta: "Begär migration",
        },
        repairAnalysisSection: {
            title: "Reparera eller sälja? Låt datan avgöra.",
            subtitle: "Professionell ekonomisk analys för ditt fordon. Sluta gissa och börja veta om de reparationerna verkligen är värda det.",
            features: {
                personalized: {
                    title: "Personlig Analys",
                    description: "För dina spårade bilar använder vi verkliga historiska kostnader och parametrar, och lägger till planerade kostnader för att generera en bedömning.",
                },
                public: {
                    title: "Offentlig Simulator",
                    description: "Utvärderar du ett potentiellt köp? Använd vårt offentliga verktyg på /repair för att generera en detaljerad analys genom att ange bara några nyckeldetaljer.",
                },
                whatIf: {
                    title: "Vad-Om Simulator",
                    description: "Ange en planerad reparationskostnad och se omedelbart hur det påverkar din bils ekonomiska poäng.",
                },
            },
            cta: "Visa exempelanalys",
        },
        faq: {
            title: "Vanliga frågor",
            subtitle: "Allt du behöver veta om My Car Costs",
            questions: {
                mobileApps: {
                    question: "Kommer det att finnas iOS- och Android-appar?",
                    answer: "Ja! Mobilappar för både iOS och Android kommer snart. Vi arbetar hårt för att ge dig den bästa mobila upplevelsen.",
                },
                dataPrivacy: {
                    question: "Är mina uppgifter privata och säkra?",
                    answer: "Absolut. Dina uppgifter är krypterade och lagras säkert. Endast du kan få tillgång till din bilinformation om du inte uttryckligen väljer att göra den offentlig.",
                },
                freePlan: {
                    question: "Är den gratis planen verkligen gratis för alltid?",
                    answer: "Ja! Den gratis planen kommer alltid att vara tillgänglig med en bil och alla nödvändiga funktioner. Du kan uppgradera till Pro när som helst för upp till 3 bilar och avancerade funktioner.",
                },
                dataExport: {
                    question: "Kan jag exportera mina uppgifter?",
                    answer: "Ja, du kan exportera alla dina uppgifter när som helst i CSV- eller PDF-format. Dina uppgifter är dina, och du är aldrig låst.",
                },
                emailImport: {
                    question: "Hur fungerar e-postimport?",
                    answer: "Varje bil får en unik e-postadress. Framåt bara dina fakturor så extraherar vi datan automatiskt.",
                },
                multipleUsers: {
                    question: "Kan flera personer få tillgång till samma bil?",
                    answer: "För närvarande tillhör varje bil ett konto. Du kan dock göra en bil offentligt synlig för att dela läsbehörighet med andra.",
                },
            },
        },
        cta: {
            title: "Sluta gissa. Börja veta.",
            subtitle: "Förvandla din bils historik till tydliga ekonomiska beslut. Gå med i tusentals smarta ägare som vet exakt när de ska investera eller sälja.",
            button: "Kom igång nu",
            note: "Ingen kreditkort. Ingen påträngande försäljning. Bara klarhet.",
        },
        footer: {
            product: "Produkt",
            legal: "Juridiskt",
            changelog: "Ändringslogg",
            privacy: "Integritetspolicy",
            contact: "Kontakt",
            contactEmail: "info@mycarcosts.com",
            questions: "Har du några frågor? Kontakta oss på:",
        },
        privacy: {
            title: "Integritetspolicy",
            lastUpdated: "Senast uppdaterad: 25 mars 2026",
            introduction: "På My Car Costs tar vi din integritet på allvar. Denna policy förklarar hur vi hanterar dina uppgifter.",
            dataCollection: {
                title: "Datainsamling",
                description: "Vi samlar endast in den absolut minimiinformation som krävs för att tillhandahålla vår tjänst.",
                email: "Kontots Identitet: Vi använder din e-postadress som din unika identifierare och för autentisering (t.ex. magiska länkar eller Google-inloggning).",
                documents: "Dokumentlagring: Filer du laddar upp lagras säkert i krypterad molnlagring.",
            },
            carData: {
                title: "Din Datakontroll",
                description: "Information du anger (kostnader, körsträcka, delar) lagras för ditt personliga bruk och analys.",
                noValidation: "Vi validerar inte bilinformationen du tillhandahåller; det är ditt ansvar att säkerställa noggrannhet.",
                privateByDefault: "Som standard är dina data privata. Tekniska identifierare för filer är icke-sekventiella och indexeras inte av sökmotorer.",
                rightToForgotten: "Rätt att bli Glömd: Du kan radera ditt konto när som helst, vilket omedelbart och permanent tar bort alla dina register och filer.",
            },
            thirdParty: {
                title: "Tredjepartstjänster",
                description: "Vi säljer inte dina personuppgifter. När du använder Google-inloggning får vi endast tillgång till din e-postadress för identifieringsändamål.",
            },
            emailIngestion: {
                title: "E-postinhämtning",
                description: "E-post som skickas till vår inhämtningstjänst lagras för att ge en bearbetningshistorik. Du kan manuellt radera enskilda e-postmeddelanden eller hela din historik när som helst.",
            },
        },
        emails: {
            deleteAll: "Radera alla",
            deleteAllConfirm: "Är du säker på att du vill radera hela e-posthistoriken för denna bil? Denna åtgärd är oåterkallelig.",
            deleteConfirm: "Är du säker på att du vill radera detta e-postmeddelande?",
            noEmails: "Inga e-postmeddelanden mottagna än.",
        },
        terms: {
            title: "Allmänna Villkor",
            lastUpdated: "Senast uppdaterad: 25 mars 2026",
            introduction: "Genom att gå in på eller använda MyCarCosts godkänner du att vara bunden av dessa Allmänna Villkor. Om du inte samtycker, vänligen använd inte vår tjänst.",
            acceptance: {
                title: "1. Godkännande av Villkor",
                description: "Dessa villkor utgör ett juridiskt bindande avtal mellan dig och MyCarCosts gällande din användning av vår applikation och våra tjänster.",
            },
            service: {
                title: "2. Beskrivning av Tjänsten",
                description: "MyCarCosts tillhandahåller en plattform för spårning av fordonskostnader, underhållshantering och ekonomisk analys. Detta inkluderar AI-driven tolkning av kvitton och verktyg för datavisualisering.",
            },
            responsibilities: {
                title: "3. Användaransvar",
                description: "Du ansvarar för noggrannheten i alla data du anger, inklusive körsträcka, VIN-nummer och kostnader. Du måste hålla dina inloggningsuppgifter (e-post/magisk länk) säkra och inte dela dem med obehöriga parter.",
            },
            plans: {
                title: "4. Tjensteplaner och Gränser",
                description: "Vi erbjuder Free- och Pro-planer med olika lagrings-, bilantals- och uppladdningsgränser. Vi förbehåller oss rätten att ändra dessa gränser eller introducera nya prenumerationsnivåer när som helst.",
            },
            disclaimer: {
                title: "5. Friskrivningar och Noggrannhet",
                description: "MyCarCosts är ett informations- och organisationsverktyg. Vi tillhandahåller inte officiella certifieringar för fordonsstatus. AI-tolkad data från kvitton bör alltid verifieras av användaren för noggrannhet.",
            },
            liability: {
                title: "6. Ansvarsbegränsning",
                description: "MyCarCosts tillhandahålls 'i befintligt skick'. Vi ansvarar inte för några mekaniska problem, ekonomiska förluster eller felaktigheter i data som uppstår till följd av användningen av vår applikation.",
            },
            termination: {
                title: "7. Uppsägning",
                description: "Du kan sluta använda tjänsten och radera dina data när som helst. Vi förbehåller oss rätten att stänga av eller avsluta konton som bryter mot dessa villkor eller uppvisar missbruk.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

